<div class="card">
  <div class="card-body">
    <h4 class="card-title">Informazioni generali</h4>
    <div class="row">
      <!--      <div class="col-sm-12 col-md-6">-->
      <!--        <div class="form-group">-->
      <!--          <label for="prodotto" class="control-label col-form-label">Nome:</label>-->
      <!--          <input [(ngModel)]="Materiale.nome" type="text" class="form-control" id="prodotto" placeholder="Nome">-->
      <!--        </div>-->
      <!--      </div>-->
      <div class="col-sm-12 col-lg-3">
        <div class="form-group">
          <label for="codice" class="control-label col-form-label">Nome:</label>
          <input [(ngModel)]="Materiale.nome" type="text" class="form-control" id="codice" placeholder="Nome">
        </div>
      </div>
      <div class="col-sm-12 col-lg-3">
        <div class="form-group">
          <label for="codice" class="control-label col-form-label">ID_Articolo:</label>
          <input [(ngModel)]="Materiale.codice" type="text" class="form-control" id="codice" placeholder="ID_Articolo">
        </div>
      </div>
      <div class="col-sm-12 col-lg-3">
        <div class="form-group">
          <label for="codice_produttore" class="control-label col-form-label">ID_Articolo Produttore:</label>
          <input [(ngModel)]="Materiale.codice_produttore" type="text" class="form-control" id="codice_produttore"
            placeholder="ID_Articolo Produttore">
        </div>
      </div>
      <div class="col-sm-12 col-lg-3">
        <label for="categorie" class="control-label col-form-label">Categorie:</label>
        <ng-multiselect-dropdown [settings]="DropdownSettings" style="width: 80%; " id="categorie"
          [placeholder]="'Seleziona'" name="categorie" [data]="Categorie" [(ngModel)]="CategorieSelezionate">
        </ng-multiselect-dropdown>
      </div>
      <div class="col-sm-12 col-lg-3" *ngIf="PartiEcommerce?.length > 0">
        <label for="categorie" class="control-label col-form-label">Parti Equivalenti Ecommerce:</label>
        <ng-multiselect-dropdown [settings]="partiDropdownSettings" style="width: 80%; " [placeholder]="'Seleziona'"
          name="categorie" [data]="PartiEcommerce" [(ngModel)]="PartiEcommerceSelezionate">
        </ng-multiselect-dropdown>
      </div>
      <div class="col-sm-12 col-lg-2">
        <div class="form-group">
          <label for="prezzo" class="control-label col-form-label">Prezzo:</label>
          <input [(ngModel)]="Materiale.prezzo" type="number" min="0" step="0.001" class="form-control" id="prezzo"
            placeholder="Prezzo">
        </div>
      </div>
      <div class="col-sm-12 col-lg-2">
        <div class="form-group">
          <label for="um" class="control-label col-form-label">Unità:</label>
          <ng-multiselect-dropdown [settings]="SingleClassicTypeDownSettings" style="width: 80%; " id="um"
            [placeholder]="'Seleziona'" name="categorie" [data]="UM" [(ngModel)]="UMSelezionate">
          </ng-multiselect-dropdown>
        </div>
      </div>
      <div class="col-sm-12 col-lg-2">
        <div class="form-group">
          <label for="magazzino" class="control-label col-form-label">Magazzino:</label>
          <input [(ngModel)]="Materiale.magazzino" type="numeric" class="form-control" id="magazzino"
            placeholder="Magazzino">
        </div>
      </div>
      <div class="col-sm-12 col-lg-2">
        <div class="form-group">
          <label for="scorta" class="control-label col-form-label">Scorta Minima:</label>
          <input [(ngModel)]="Materiale.scortaMin" type="numeric" class="form-control" id="scorta"
            placeholder="Scorta Minima">
        </div>
      </div>
      <div class="col-sm-12 col-lg-2">
        <div class="form-group">
          <label for="fornitore" class="control-label col-form-label">Fornitore:</label>
          <ng-multiselect-dropdown [settings]="clientiDropdownSettings" [placeholder]="'Fornitore' | translate"
            id="fornitore" [data]="Fornitori" [(ngModel)]="Materiale.fornitoreObject"
            (ngModelChange)="FornitoreChange($event, Materiale)">
          </ng-multiselect-dropdown>
        </div>
      </div>
      <div class="col-md-3">
        <h5 class="card-title m-t-20">{{'prodotti.UploadImage' | translate}}</h5>
        <div class="el-element-overlay">
          <div class="el-card-item">
            <div class="el-card-avatar el-overlay-1">
              <img *ngIf="Materiale.UrlImmagine || Materiale.immagine"
                [src]="Materiale.immagine ? Materiale.immagine : Materiale.UrlImmagine"
                (error)="onImageError(Materiale)" alt="user" />
              <div class="el-overlay">
                <ul class="list-style-none el-info">
                  <li class="el-item" *ngIf="Materiale.UrlImmagine">
                    <a class="btn default btn-outline image-popup-vertical-fit el-link" [href]="Materiale.UrlImmagine">
                      <i class="icon-magnifier"></i>
                    </a>
                  </li>
                  <li class="el-item">
                    <a class="btn default btn-outline el-link" href="javascript:void(0);">
                      <i class="icon-link"></i>
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        <div class="btn btn-info waves-effect waves-light">
          <span>Upload Anonther Image</span>
          <input type="file" class="upload" (change)="ImageChange($event, 'immagine', 'image', 'file')">
        </div>
      </div>
      <div class="col-sm-12 col-lg-12" *ngIf="environment['MaterialiAddOn']">
        <app-field-viewer [(Oggetto)]="Materiale" [(Campi)]="environment['MaterialiAddOn']['CampiAggiuntivi']"
          (OnChange)="Change($event)" [(DropdownSources)]="DropdownSources"></app-field-viewer>

      </div>
    </div>
    <!--    <app-translated-desc class="col-sm-12 col-lg-12" [col4]="true" [(data)]="Materiale.transaltedobjects"></app-translated-desc>-->
    <div class="d-md-flex align-items-center" style="padding-right: 25px;">
      <button type="submit" (click)="saveClick()" class="ml-auto btn btn-success p-2 waves-effect waves-light">
        <span class="ml-1 text-white font-weight-bold"> Salva </span>
        <i-feather name="save" class="feather-md "></i-feather>
      </button>
    </div>
  </div>
</div>
<div class="card">
  <div class="card-body">
    <h4 class="card-title">Acquisti</h4>

    <table class="table bg-white table-hover align-middle mb-0">
      <thead>
        <tr>
          <th scope="col">Quantita</th>
          <th scope="col">Prezzo</th>
          <th scope="col">Data</th>
          <th scope="col">Fornitore</th>
          <th scope="col">Azioni</th>
        </tr>
      </thead>
      <tbody>
        <tr
          *ngFor="let acquisto of Acquisti?.data | slice: (paginationValue.page-1) * paginationValue.pageSize : (paginationValue.page-1) * paginationValue.pageSize + paginationValue.pageSize">
          <td class="align-middle">
            {{acquisto.quantita}}
          </td>
          <td class="align-middle">
            {{acquisto.prezzo}} €
          </td>
          <td class="align-middle">
            {{acquisto.data | date: 'dd/MM/yyyy'}}
          </td>
          <td class="align-middle">
            {{acquisto.fornitore}}
          </td>
          <td class="align-middle">
            <a href="javascript:void(0)" *ngIf="!acquisto.consegnato" (click)="Arrivati(acquisto)"
              class="link text-warning font-16 font-medium mr-2"><i class="fas fa-truck"></i></a>
          </td>
        </tr>
      </tbody>
    </table>
    <div class="d-flex justify-content-center p-2 pt-3 bg-white border-top">
      <ngb-pagination (pageChange)="getPage($event)" [maxSize]="10"
        [collectionSize]="Acquisti?.total ?? Acquisti?.data?.length ?? 0"
        [pageSize]="paginationValue.pageSize"></ngb-pagination>
    </div>
  </div>
</div>
<!-- <div *ngIf="hasParti && selected" >
  <app-parti-prodotto [Variazioni]="selected.variazioni" [Parti]="selected.parti"></app-parti-prodotto>
</div> -->
<!--<div *ngIf="!showaddform" class="card">-->
<!--  <app-file-uploader (onChange)="onFileChanged()"></app-file-uploader>-->
<!--</div>-->